import { Cards } from "@/components/sections/Cards";
import { Gallery } from "@/components/sections/Gallery";
import { GravityForm } from "@/components/sections/GravityForm";
import { Hero } from "@/components/sections/Hero";
import { Prose } from "@/components/sections/Prose";
import type { Section } from "@/types/global";

export function SectionRenderer({ sections }: { sections: Section[] }) {
  return (
    <>
      {sections.map((section, i) => {
        switch (section.type) {
          case "hero":
            return <Hero key={i} {...section} />;
          case "prose":
            return <Prose key={i} {...section} />;
          case "cards":
            return <Cards key={i} {...section} />;
          case "gallery":
            return <Gallery key={i} {...section} />;
          case "gravity_form":
            return <GravityForm key={i} {...section} />;
          default:
            return null;
        }
      })}
    </>
  );
}
